









import { Vue, Component } from 'vue-property-decorator'
import { asyncAlert } from "@/galaxy-cruise/components/AsyncAlert";
import AlertContent from "./AlertContent.vue";
import { store } from '../../../store';

@Component
export default class extends Vue {
  async asyncAlert() {
    await asyncAlert({ component: AlertContent })
  }

  get gc() {
    return store.galaxyCruise
  }

  get session() {
    return this.gc.session
  }

  back() {
    this.$router.back()
  }
}
